module.exports = __webpack_public_path__ + "static/media/thumbnail-taibamedina.5cd2f1cf.jpeg";